import React from "react";
import { Play } from "lucide-react";
import MillstageDropDownFilter from "../../../../components/FilterBox/Millstage/MillstageDropDownFilter";

const AccessGate = ({
  isGateLoading,
  gateStageVal,
  setGateStageVal,
  gateStageId,
  setGateStageId,
  gateTxnVal,
  setGateTxnVal,
  gateTxnId,
  setGateTxnId,
  handleGo,
  stagesList,
  txnTypes,
  themeColors
}) => {
  const {
    bgCard,
    borderTheme,
    btnBg,
    btnText,
    headingCol,
    iscolour,
    iscolourDark,
    isdark
  } = themeColors;

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "80vh" }}
    >
      <div
        style={{
          background: bgCard,
          borderRadius: "16px",
          padding: "30px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          border: `1px solid ${borderTheme}`
        }}
      >
        <div className="text-center mb-4">
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: btnBg,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "24px",
              marginBottom: "15px",
              boxShadow: `0 0 18px ${btnBg}60`
            }}
          >
            ✦
          </div>
          <h4 style={{ fontWeight: "800", color: headingCol, letterSpacing: "0.5px" }}>LOT ENTRY PORTAL</h4>
          <p style={{ color: isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540", fontSize: "14px" }}>
            Verify credentials and destination department stage rules
          </p>
        </div>

        {isGateLoading ? (
          <div className="py-5 text-center d-flex flex-column align-items-center justify-content-center gap-3">
            <div className="theme-spinner"></div>
            <div className="theme-loader-text">VERIFYING STAGE CREDENTIALS...</div>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <MillstageDropDownFilter
                label="To Stage"
                data={stagesList}
                selectedValue={gateStageVal}
                setSelectedValue={setGateStageVal}
                selectedId={gateStageId}
                setSelectedId={setGateStageId}
                isMulti={false}
                placeholder="Select Destination Stage"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </div>

            <div className="mb-4">
              <MillstageDropDownFilter
                label="Transaction Type"
                data={txnTypes}
                selectedValue={gateTxnVal}
                setSelectedValue={setGateTxnVal}
                selectedId={gateTxnId}
                setSelectedId={setGateTxnId}
                isMulti={false}
                placeholder="Select Transaction Priority"
                
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </div>

            <button
              onClick={handleGo}
              disabled={isGateLoading}
              style={{
                width: "100%",
                padding: "12px",
                background: btnBg,
                color: btnText,
                border: "none",
                borderRadius: "12px",
                fontWeight: "700 ",
                fontSize: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                transition: "0.25s"
              }}
              className="hover-scale-btn"
            >
              <Play size={18} />
              <span>Enter Workspace</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AccessGate;
